
import React, { useState } from 'react';
import Started from './sections/started';

const Layout = (props) => {
    return <Started applicantId={props.applicantId} />
}

export default Layout;
